import { useEffect, useState } from 'react';
import { Alert, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { staffErrorText } from './staffText';

/** Confirmación de una acción sobre una cuenta. Con `requireCheck` hay que tildar que se entiende que no se puede deshacer. */
const StaffConfirmDialog = ({ open, title, message, confirmLabel, color = 'primary', requireCheck = false, onClose, onConfirm }) => {
  const [checked, setChecked] = useState(false);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setChecked(false);
      setWorking(false);
      setError('');
    }
  }, [open]);

  const handleConfirm = async () => {
    setWorking(true);
    setError('');
    try {
      await onConfirm();
    } catch (err) {
      setError(staffErrorText(err));
      setWorking(false);
    }
  };

  return (
    <Dialog open={open} onClose={working ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>{message}</Typography>
        {requireCheck && (
          <FormControlLabel
            control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
            label="Entiendo que no se puede deshacer"
          />
        )}
        {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={working}>Cancelar</Button>
        <LoadingButton variant="contained" color={color} loading={working} disabled={requireCheck && !checked} onClick={handleConfirm}>
          {confirmLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default StaffConfirmDialog;
